import React, { Component } from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ContCharacteristics from '../../../selections/characteristics/containers/ContCharacteristics';
import './../../../sig/selections/expands/Styles.css';
import { CARACTERISTICA } from '../../../../constants/icons/gis/gis';
import { Grid } from '@material-ui/core';

class ExpandCharacteristics extends Component {

    handleExtendCh = (caracteristicas) => {
        //console.log("Estamos en el expand")
        this.props.SelCaracteristicas(caracteristicas);
    }

    handleOcupacion = (value) => {
        //console.log("890",value);
        this.props.onOcupacion(value);
    }

    render() {
        const { fenomeno } = this.props;
        const { gerencia } = this.props;
        const { Seleccion } = this.props;

        return (
            <Grid container style={{ minWidth: '290px' }}>
                <Grid xs={12} item>
                    <ExpansionPanel>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon className="iconColor"/>} >
                            <Grid className="ContExpand">
                                <Grid className="compExpandTitle">
                                    {
                                        Seleccion !== "GIS"
                                            ? <Grid></Grid>
                                            : <Grid>{CARACTERISTICA}</Grid>
                                    }
                                </Grid>
                                <Grid className="compExpandTitle">
                                    Selección Características
                                </Grid>
                            </Grid>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails style={{ display: 'list-items' }}>
                            <Grid xs={12} item className="ExpandNewSpaceSelection" >
                                <Grid>
                                    <ContCharacteristics
                                        fenomeno={fenomeno}
                                        gerencia={gerencia}
                                        caracteristicas={this.handleExtendCh}
                                        onOcupacion={this.handleOcupacion}
                                        Seleccion={Seleccion}
                                        caracteristicasArray={this.props.caracteristicasArray}
                                        dataResult={this.props.dataResult}
                                    />
                                </Grid>
                                {/* <Grid>
                                    <ApplyFilter/>
                                </Grid> */}
                            </Grid>

                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                </Grid>
            </Grid>
        );
    }

}

export default ExpandCharacteristics;